import React from 'react';
import { Link } from "react-router-dom";
import {ArrowLeft} from '@untitledui/icons/ArrowLeft';

const BackButton = ({href, className}) => {
    return (
        <Link className={`back-button flex flex-align-center ${className || ''}`} to={href}>
            <ArrowLeft />
            Back
        </Link>
    );
}

export default BackButton;